import { render, staticRenderFns } from "./AccountTreeConfig.vue?vue&type=template&id=73a60b2c&scoped=true&"
import script from "./AccountTreeConfig.vue?vue&type=script&lang=js&"
export * from "./AccountTreeConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a60b2c",
  null
  
)

export default component.exports